import styled from 'styled-components'

const Error = styled.div`
  background: ${p => p.theme.colors.err};
  color: #fff;
  padding: 16px;
  font-size: 14px;
`

export default Error